export interface KeywordMappingSearchIntent {
    service_id: number
    serviceName: string
    countryCode: string
    search_intent: string
    keywordCount: number
    activeKeywordCount: number
    h1TextCount: number
    h1Text: string | null
}

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null
}

function readCount(value: unknown): number | null {
    if (typeof value !== 'number') return null
    if (Number.isInteger(value) === false) return null
    if (value < 0) return null
    return value
}

export function readKeywordMappingSearchIntent(value: unknown): KeywordMappingSearchIntent | null {
    if (!isRecord(value)) return null
    if (typeof value.service_id !== 'number') return null
    if (typeof value.serviceName !== 'string') return null
    if (typeof value.countryCode !== 'string') return null
    if (typeof value.search_intent !== 'string') return null
    if (value.h1Text !== null && typeof value.h1Text !== 'string') return null

    const keywordCount = readCount(value.keywordCount)
    const activeKeywordCount = readCount(value.activeKeywordCount)
    const h1TextCount = readCount(value.h1TextCount)
    if (keywordCount === null) return null
    if (activeKeywordCount === null) return null
    if (h1TextCount === null) return null

    return {
        service_id: value.service_id,
        serviceName: value.serviceName,
        countryCode: value.countryCode,
        search_intent: value.search_intent,
        keywordCount,
        activeKeywordCount,
        h1TextCount,
        h1Text: value.h1Text,
    }
}

export function keywordMappingSearchIntentRowId(value: unknown): string {
    const item = readKeywordMappingSearchIntent(value)
    if (item === null) {
        const encoded = JSON.stringify(value)
        if (typeof encoded !== 'string') return 'unreadable'
        return `unreadable:${encoded}`
    }

    return JSON.stringify([item.service_id, item.search_intent])
}
